import { render, staticRenderFns } from "./UnitsForm.vue?vue&type=template&id=6c356e18&"
import script from "./UnitsForm.vue?vue&type=script&lang=js&"
export * from "./UnitsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports